<template>
    <el-row type="flex" class="flex-align-center flex-pack-center">
        <div class="addStore">
            <div class="title" v-if="isEnterInviteCode">请输入邀请码</div>
            <div class="title" v-if="!isEnterInviteCode">添加店铺</div>

             <div class="back" @click="()=>{ $router.push({path:'/login'}) }">
                <i class="iconfont icon-return"></i>
                <span>返回</span>
            </div>
            <form @submit.prevent>
                <div v-if="isEnterInviteCode" class="inviteCode">
                    <input type="text" v-model="newStore.referralCode" @keyup.enter="checkInviteCode" placeholder="请输入您的邀请码">
                </div>
                <div v-if="!isEnterInviteCode" class="storeMsg">
                    <div class="storeMsgItem nameInput">
                        <input type="text" v-model="newStore.name" placeholder="请输入店铺名">
                    </div>
                    <div class="storeMsgItem">
                        <el-select v-model="newStore.typeId" placeholder="请选择店铺类型">
                            <el-option
                                v-for="item in storeType"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="storeMsgItem addrInput">
                        <input type="text" v-model="newStore.addr" placeholder="请输入地址">
                    </div>
                </div>
                <div class="confirmBtn">
                    <!-- <button v-if="isEnterInviteCode" type="button" @click="()=>{$router.push({path:'/login'})}" class="back">返回</button> -->
                    <button v-if="isEnterInviteCode" type="button" @click="checkInviteCode">下一步</button>
                    <button v-if="!isEnterInviteCode" type="button" @click="addStore" @keyup.enter="addStore">下一步</button>
                </div>
            </form>
        </div>
        <div class="noStoreMask" v-if="isFirstAddStore">
            <div class="logo">
                <img src="../../assets/store/logo-white.png" alt="">
            </div>
            <div class="noStoreBox">
                <div class="title">添加店铺</div>
                <div class="tipText">暂无相关店铺数据，请新建店铺信息</div>
                <div class="btnGroup">
                    <button type="button" @click="isFirstAddStore=false">
                        <i class="iconfont icon-add"></i>
                        新建店铺
                    </button>
                </div>
            </div>
        </div>
    </el-row>
</template>

<script type="text/javascript">
    import {url} from '@/router/url.js';
    export default{
        data () {
            return {
                isFirstAddStore: false, // 是否第一次添加店铺
                isEnterInviteCode: true, // 是否在输入邀请码界面
                storeType: [],
                newStore: {
                    "name": "", // 店铺名称
                    "typeId": "", // 店铺类型id
                    "addr": "", // 店铺地址
                    "referralCode": "" // 邀请码
                },
                curStoreId: '', // 当前店铺id
                addStoreCtrlBtn:true
            }
        },
        methods: {
            // 校验邀请码
            checkInviteCode: function () {
                if(!this.newStore.referralCode){
                   this.$message({
                        message: '请输入邀请码',
                        customClass: 'error'
                    });
                    return; 
                }
                let that = this;
                this.$http.get('/validate-referral-code?code='+this.newStore.referralCode).then((res)=>{
                    this.isEnterInviteCode = false;
                }).catch(function ( err ) {
                })
            },
            // 添加店铺
            addStore: function () {
                console.log(123)
                if ( !this.newStore.name ) {
                    this.$message({
                        message: '请输入店铺名',
                        customClass: 'error'
                    });
                    return;
                }
                if ( !this.newStore.addr ) {
                    this.$message({
                        message: '请输入店铺地址',
                        customClass: 'error'
                    });
                    return;
                };
                if ( !this.curStoreId ) {
                    this.curStoreId = this.$uuid.create(1).hex;
                };
                if ( !this.addStoreCtrlBtn ) {
                    return;
                };
                this.addStoreCtrlBtn = false;
                // let msg = this.$message({
                //     message: '店铺创建中，请耐心等待。',
                //     duration:0,
                //     customClass: 'success'
                // });
                let loading = this.$loading({
                    lock: true,
                    text: '店铺创建中，请耐心等待。',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                this.$http.put('/stores/'+this.curStoreId, this.newStore).then((res)=>{
                    this.addStoreCtrlBtn = true;
                    loading.close();
                    this.$router.push({path:'/store'});
                }).catch((err) => {
                    loading.close();
                    this.addStoreCtrlBtn = true;
                })
            }
        },
        created: function () { 
            if ( this.$route.params.isFirst ) {
                this.isFirstAddStore = true;
            }

            // 进入界面时请求店铺类型
            this.$http.get('/store-types').then((res)=>{
                this.storeType = res.data;
                if ( this.storeType && this.storeType[0] ) {
                    this.newStore.typeId = this.storeType[0].id;
                };
            }).catch();
        }
    }
</script>
<style lang="scss" scoped>
    @import '../../../static/css/common.scss';
    @import "addStore";
</style>



// WEBPACK FOOTER //
// addStore.vue?f26f20fe